import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AnimalPhotos.css';
import { Fetch, API_BASE } from '../utils/Utils.js';
import { formatDate as formatDateLocale } from '../../utils/dateFormat.js';

// AnimalPhotos is the dated photo log for an animal, by tag — backed by
// internal/animals/photos (animals.photos collection). Deliberately a log,
// not a single overwritten "profile pic": a photo's date is the point (e.g.
// proof-of-possession, or visual history across weight checks/pregnancy
// stages). Read-only here — photos are added from Tag Detector
// (posso-help-native-app), not from the dashboard.
export const AnimalPhotos = ({ tag }) => {
  const { t } = useTranslation();
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    Fetch(`/api/animals/${tag}/photos`, 'get', null,
      (data) => setPhotos(data || []),
      () => {}
    );
  }, [tag]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return formatDateLocale(date) + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="animal-photos">
      <div className="photos-header">
        <span className="photos-icon">&#128247;</span>
        <h4>{t('photos')}</h4>
      </div>

      {photos.length === 0 ? (
        <p className="no-photos">{t('no_photos')}</p>
      ) : (
        <div className="photos-strip">
          {photos.map((p) => (
            <div key={p._id} className="photo-item">
              <img src={`${API_BASE}${p.path}`} alt={`Tag ${p.tag}`} className="photo-thumb" />
              <span className="photo-date">{formatDate(p.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnimalPhotos;
